

export const currentImage = (imgPath) => dispatch => {
    dispatch({
        type: 'CURRENT_IMAGE',
        payload: imgPath
    });
}